<template>
  <el-dialog title="注册" :visible.sync="show" width="748px" class="registerWrapper" @close="$emit('cancel'),fileList = []">
    <el-form :model="form" :rules="rules" ref="registerForm">
      <!-- <div class="inline">
        <el-form-item label="登录账号" prop="username">
          <el-input v-model="form.username" class="input" maxlength="20" clearable placeholder="本平台登录账号，支持20位以内数字、字母组合"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="form.password" class="input" maxlength="20" clearable show-password placeholder="支持8-20位数字、字母组合"></el-input>
        </el-form-item>
      </div> -->
      <div class="inline">
        <el-form-item label="机构名称" prop="orgName">
          <el-input v-model="form.orgName" class="input" maxlength="20" placeholder="请输入贵司名称" clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile">
          <el-input @input="handleNumberInput" v-model="form.mobile" class="input" maxlength="20" placeholder="您的电话号码" clearable show-word-limit></el-input>
        </el-form-item>
      </div>
      <div style="font-size: 14px;font-weight: 500;color: #333333;display: flex;margin-bottom: 10px;">
        机构图片
      </div>
      <div class="demo-image-upload">
        <!-- :on-preview="handlePreview" -->
        <el-upload
          action="#"
          list-type="picture-card"
          :auto-upload="false"
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          accept="image/*"
          multiple>
          <!-- 上传按钮 -->
          <i class="el-icon-plus"></i>
          <!-- 提示文字 -->
        </el-upload>

        <!-- 图片预览对话框 -->
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </div>
      <div style="font-size: 12px;color: #1D91FC;display: flex;margin-top: 5px;">
        请上传机构相关图片，支持PNG\JPG格式，至多3张图片
      </div>
      <el-form-item label="机构简介" prop="intro">
        <el-input
          type="textarea"
          v-model="form.intro"
          :rows="4"
          maxlength="500"
          show-word-limit
          clearable
          placeholder="请输入贵公司简介">
        </el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          v-model="form.remarks"
          :rows="4"
          maxlength="500"
          show-word-limit
          clearable
          placeholder="备注：来电时间/如不便通话，可留下微信/QQ联系">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="loginBtn" @click="submitForm('registerForm')">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Register',
  props: {
    registerVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      showRegister: true,
      form: {
        username: '',
        password: '',
        orgName: '',
        mobile: '',
        remarks: '',
        intro: '',
        dialogVisible: false
      },
      rules: {
        orgName: [
          { required: true, message: '请输入贵司名称', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入您的电话', trigger: 'change' }
        ],
        intro: [
          { required: true, message: '请输入贵公司简介', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    registerVisible: {
      handler (nval) {
        this.show = nval
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 处理文件预览
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    // 超出文件数量限制
    handleExceed () {
      this.$message.warning('最多只能上传3张图片')
    },

    // 删除文件
    handleRemove (file, fileList) {
      this.fileList = fileList
    },

    // 上传前处理（生成预览）
    beforeUpload (file) {
      // 验证图片类型
      const isImage = file.type.includes('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB!')
        return false
      }

      // 生成预览图
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = e => {
        // 创建带预览的文件对象
        const previewFile = Object.assign(file, {
          url: e.target.result
        })
        if (this.fileList.length < 3) {
          this.fileList = [...this.fileList, previewFile]
        }
      }
      return false // 阻止自动上传
    },
    handleNumberInput (value) {
      this.form.mobile = value.replace(/[^\d]/g, '')
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form)
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.form.orgName = ''
      this.form.mobile = ''
      this.form.remarks = ''
    }
  }
}
</script>
<style scoped>
.registerWrapper >>> .el-dialog{
  border-radius: 10px;
}
.demo-image-upload >>> .el-upload-list__item{
  width: 64px;
  height: 64px;
}
.demo-image-upload >>> .el-upload--picture-card{
  width: 64px;
  height: 64px;
  line-height: 74px;
}
</style>
<style scoped lang="scss">
  .showRegister{
    display: block;
  }
  .hiddenRegister{
    display: none;
  }
  .registerWrapper{
    // height: 544px;
    width: 100%;
    .input{
      width: 340px;
    }
    .el-form-item{
      margin-bottom: 12px;
    }
    .inline{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .demo-image-upload{
      display: flex;
    }
    .dialog-footer{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .loginBtn{
        width: 150px;
        background-color: #BC1A33;
        border-color: #BC1A33;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
</style>
